<template>
  <BasicTemplate>
    <h3>
      <router-link to="/games">Games</router-link> /
      <router-link :to="`/games/${$route.params.gameId}`">Game #{{ $route.params.gameId }}</router-link> /
      Game Meta #{{$route.params.id}}: {{ item?.name }}
    </h3>
    <Form :game="game" :item="item" @change="save()" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../../templates/basic.vue';
import Form from './form.vue';

export default {
  name: 'MetaEdit',
  components: { BasicTemplate, Form },
  data() {
    return {
      game: {},
      item: {},
    };
  },
  async created() {
    this.$watch(() => this.$route.params, (newParams, prevParams) => this.load());
    await this.load();
  },
  methods: {
    async load() {
      const { gameId, id } = this.$route.params;
      this.game = await this.$gameApi.get(`/games/${gameId}`);
      this.item = this.game.gameMetas.find(m => m.id == id);
    },
    async save() {
      try {
        const { gameId, id } = this.$route.params;
        this.item = await this.$gameApi.patch(`/games/${gameId}/metas/${id}`, this.item);
        this.$swal.fire({ icon: 'success', title: 'Game meta saved.', timer: 1500, showConfirmButton: false });
      } catch (e) {
        this.$swal.fire({ icon: 'error', title: e.message, timer: 1500, showConfirmButton: false });
      }
    }
  }
};
</script>

